export const environment = {
  version: 'release-kw34',
  buildDate: '202608310933',
  environment: 'release-kw34',
  release: 'cf2bf813606741d24cfb405ac9f52791213b6642',
  production: false,
  debug: true,
  baseUrl: 'https://release-kw34.leads.catch-talents.dev',
  apiUrl: 'https://release-kw34.api.catch-talents.dev',
  apiUrlFallback: 'https://develop.api.catch-talents.dev',
  companyBaseUrl: 'https://release-kw34.company-tool.catch-talents.dev',
  jobboardBaseUrl: 'https://release-kw34.jobboard.catch-talents.dev',
};
